
import Rellax from 'rellax';
var rellax = document.querySelectorAll('.rellax');
rellax.forEach(function(e){
    new Rellax(e)
})
